export default {
  UnRelease: 0,
  IsReleased: 2,
  ReleaseError: 4,
  NoSendTax: 5,
  SendTax: 6,
  SaleInvoiceInValid: 8,
  Rejected: 7,
};
